import { Controller } from '@hotwired/stimulus'

export default class PasswordShowToggleController extends Controller {
  connect() {
    if (this.element.parentElement.classList.contains('password-input')) return

    const inputParent = this.element.parentElement
    const inputWrapper = document.createElement('div')
    const iconElement = document.createElement('i')

    this.element.classList.add('switchable_password')
    iconElement.classList.add('fa', 'fa-eye', 'fa-lg', 'me-2', 'password-show-toggle')
    inputWrapper.classList.add('password-input')
    iconElement.addEventListener('click', this.toggle)

    inputParent.prepend(inputWrapper)
    inputWrapper.append(this.element, iconElement)
  }

  toggle = event => {
    const iconElement = event.target
    const inputElement = iconElement.parentElement.querySelector('input')

    inputElement.type = inputElement.type === 'password' ? 'text' : 'password'
    iconElement.classList.toggle('fa-eye-slash')
    iconElement.classList.toggle('fa-eye')
  }
}
